import { useEffect, useState } from "react"

import request from "@api/request"
import setTitle from "@helpers/setTitle"
import { HOST } from "@components/constants"

const readPublicOrganizationOperation = `${HOST}/api/organizations/ReadPublicOrganization`


const usePublicOrganization = () => {
  const [ organization, setOrganization ] = useState({})

  useEffect(() => {
    request(readPublicOrganizationOperation)
      .then(({ data }) => setOrganization(data))
  }, [])

  useEffect(() => {
    const { name } = organization

    if (!name) {
      return
    }

    setTitle(name)
  }, [ organization ])

  return organization
}

export default usePublicOrganization
